package org.hs_soft.runmynesto.domain.config.language

object GermanStrings : StringResources {
    override val given="Gegeben"
    override val receiptNo = "Beleg Nr."
    override val billNumberFrom: String = "Rechnungsnummer (von)"
    override val BillNumberTo: String = "Rechnungsnummer (bis)"
    override val totalTo: String = "Gesamt (bis)"
    override val totalFrom: String = "Gesamt (von)"
    override val receiptsList = "Belegsliste"
    override val dragColumnHint="Ziehen Sie eine Spaltenüberschrift hierher, um nach dieser Spalte zu gruppieren"
    override val selectCashRegisters="Kassen auswählen"
    override val priceCategory = "Preiskategorie"
    override val fixedProducts = "Feste Produkte"
    override val gang = "Gang"
    override val addNewSelection="Neue Auswahl hinzufügen"
    override val quantity = "Menge"
    override val fixedQuantity = "Fixe Anzahl"
    override val maxQuantity = "Max Anzahl"
    override val minQuantity = "Min Anzahl"
    override val isTheMenuName = "Ist der Menüname"
    override val selection = "Auswahl"
    override val addNewPrice="Neuen Preis hinzufügen"
    override val endTime="Endzeit"
    override val individualPrice = "Individueller Preis"
    override val numberOfButtons="Anzahl der Schaltflächen"
    override val sorting = "Sortierung"
    override val sortingAutoByName = "Sortiert nach Bezeichnung"
    override val sortingAutoByNumber = "Sortiert nach Nummer"
    override val sortingManual = "Manuell"
    override val doYouWantToRemove="Möchten Sie entfernen"
    override val error= "Fehler"
    override val singleRightDoor: String = "Einzeltür rechts"
    override val singleLeftDoor: String = "Einzeltür links"
    override val newRoomName = "Neuer Raumname"
    override val floors = "Stockwerke"
    override val availableEveryWhere: String = "Überall Verfügbar"
    override val multiFactorAuthentication="Multi-Faktor-Authentifizierung"
    override val signIn="Anmelden"
    override val enterLoginRequiredData="Bitte geben Sie die erforderlichen Daten ein, um sich im System anzumelden."
    override val verificationInfo="Ihr Konto ist durch Multi-Faktor-Authentifizierung (MFA) gesichert. Bitte geben Sie den folgenden Authentifizierungscode ein, um die Anmeldung abzuschließen"
    override val noData="keine Daten"
    override val shopName="Name des Shops"
    override val edit="Edieren"
    override val price3="Price 3"
    override val altName="Alternative Artikelbezeichnung"
    override val salesUnit="Verkaufseinheit"
    override val presetRoom="Voreingestellter Raum"
    override val priceShowOnKitchenReceipt="Preis Auf Küchenbeleg anzeigen"
    override val printDishesOfTheNextCourse="Gerichte des nächsten Gangs drucken"
    override val typeOrUseVoice: String = "Tippen Sie oder verwenden Sie Ihre Stimme"
    override val availableToDownloadUntil: String = "Zum Download verfügbar bis"
    override val dataAssistantWelcomeMessage: String = "Hallo! Womit kann ich Ihnen behilflich sein?"
    override val lookingForAnswer: String="Auf der Suche nach einer Antwort..."
    override val store="Store"
    override val poiId = "POI-ID"
    override val liveEndpointUrlPrefix = "Live Endpunkt URL Präfix"
    override val apiKey = "API-Key"
    override val applicationKey = "Anwendungsschlüssel"
    override val roomId = "Raum-ID"
    override val virtualTerminalId = "virtuelle Terminal-ID"
    override val terminalId = "Terminal-ID"
    override val userId = "Benutzer-ID"
    override val posID="POS ID"
    override val tId="TID"
    override val hardware="Hardware"
    override val creditCardLink="Verknüpfung Kreditkarte"
    override val openCashDrawerAfterEFTTransaction="Kassenlade öffnen nach EFT Transaktion"
    override val tcpIP="TCP/IP"
    override val terminal="Terminal"
    override val tse="TSE"
    override val eftTerminal="EFT Terminal"
    override val apaleoPMSSubAccounts="Apaleo PMS-Unterkonto"
    override val uploadImgInfoSize="256x256 px"
    override val uploadImgInfoType="JPG, PNG"
    override val uploadManually="manuell hochladen"
    override val generateUsingAI="mit KI generieren"
    override val updatingApaleoPaymentWithCashRegister="Aktualisierung der Apaleo Zahlarten mit den Kassen Zahlarten"
    override val selectSalesGroupsForApaleoSubaccounts="Wählen Sie Vertriebsgruppen für apaleo-Unterkonten aus"
    override val clientId="Client ID"
    override val clientSecret="Client Secret"
    override val export="Export"
    override val noValidIPAddress="Keine gültige IP-Adresse"
    override val apaleoPMSProperty="Apaleo PMS-Eigenschaft"
    override val port="Port"
    override val pmsType="PMS-Typ"
    override val printReceiptAutomatically="Bon automatisch ausdrucken"
    override val transferAllDocuments="Transfer aller Belege"
    override val pms="PMS"
    override val createCard = "Karte erstellen"
    override val loading: String="Wird geladen"
    override val selected: String = "Ausgewählt"
    override val category: String = "Kategorie"
    override val turnoverGroup: String = "Umsatzgruppe"
    override val ingredients: String = "Zutaten"
    override val productNumber: String = "Artikel nummer"
    override val alcoholic: String = "Alkoholisch"
    override val vegan: String = "Vegan"
    override val vegetarian: String = "Vegetarisch"
    override val disable: String = "Deaktiviert"
    override val protel: String = "Protel"
    override val apaleo: String = "Apaleo"
    
    // Table types
    override val squaredTable: String = "Quadratischer Tisch"
    override val roundTable: String = "Runder Tisch"
    
    // Element actions
    override val addElement: String = "Element hinzufügen"
    override val editElement: String = "Element bearbeiten"
    
    // Interior design elements
    override val structure: String = "Struktur"
    override val furniture: String = "Möbel"
    override val interiorDecoration: String = "Innendekoration"
    override val indicators: String = "Indikatoren"
    
    // Structure elements
    override val horizontalWall: String = "Horizontale Wand"
    override val verticalWall: String = "Vertikale Wand"
    override val horizontalWindow: String = "Horizontales Fenster"
    override val verticalWindow: String = "Vertikales Fenster"
    override val squaredColumn: String = "Quadratische Säule"
    override val roundedColumn: String = "Runde Säule"
    override val singleDoor: String = "Einzeltür"
    override val doubleDoors: String = "Doppeltüren"
    
    // Furniture elements
    override val chair: String = "Stuhl"
    override val barStool: String = "Barhocker"
    override val armChair: String = "Sessel"
    override val twoSeaterSofa: String = "Zweisitzer-Sofa"
    override val threeSeaterSofa: String = "Dreisitzer-Sofa"
    override val cocktailBarTable: String = "Cocktail/Bartisch"
    
    // Interior decoration elements
    override val tree: String = "Baum"
    override val bush: String = "Busch"
    override val plant: String = "Pflanze"
    
    // Indicator elements
    override val exit: String = "Ausgang"
    override val wc: String = "WC"
    
    // Form inputs
    override val enterCompanyName: String = "Geben Sie den Firmennamen ein"
    override val country: String = "Land"
    override val kitchenStations: String = "Druckerstandorte"
    override val writeNewRoomNameToAdd: String = "Neuen Raumnamen zum Hinzufügen eingeben"
    
    override val tel="Tel"
    override val shopsExclusiveTemplate="Exklusive geschäfts schablone"
    override val position="Position"
    override val comparedToPreviousWeek="Verglichen mit dem gleichen Tag der Vorwoche"
    override val printerLocations="Druckerstandorte"
    override val setDefaultValuesForNewCustomer="Standardwerte für neue Kunden setzen"
    override val paymentMethods="Zahlungsarten"
    override val save="speichern"
    override val disableContentOnDevice="Deaktivieren von Inhalten auf dem Gerät"
    override val transferSettingFromCashRegister: String="Einstellungen übernehmen von Kasse"
    override val androidSerialNumber="Android Seriennummer"
    override val cashRegisterType="Kasse type"
    override val addNewBusinessOfficeDE = "Neue geschäftsstelle hinzufügen"
    override val addNewRegionDE = "Neue region hinzufügen"
    override val addNewBranchDE = "Neue filiale hinzufügen"
    override val addNewCashRegisterDE = "Neue kasse hinzufügen"
    override val addNewDevice="Neues Gerät hinzufügen"
    override val vatNormal = "MwSt normal"
    override val vatReduced = "MwSt ermäßigt"
    override val vatFree = "Keine MwSt"
    override val vatSpecial = "MwSt speziell"
    override val delete: String = "Löschen"
    override val copy: String = "Kopieren"
    override val tableNumber: String = "Tischnummer"
    override val enterTableNumber: String = "Tischnummer eingeben"
    override val seats: String = "Sitzplätze"
    override val restoMate: String = "RestoMate"
    override val restoMateDescription: String = "Ihr KI-gesteuerter Restaurant-Begleiter"
    override val dataAssistantDatabaseLoadingTitle: String = "Ihre Datenbank wird geladen..."
    override val dataLoadingProgressCategoryImportTitle: String = "Kategorien werden hochgeladen..."
    override val dataLoadingProgressMenuCardImportTitle: String = "Ihre Speisekarte wurde hochgeladen"
    override val editFloor: String = "Etage bearbeiten"
    override val list: String = "Liste"
    override val tiles: String = "Kacheln"
    override val desktopWaiter: String = "Desktop-Kellner"
    override val mobileWaiter: String = "Mobiler Kellner"
    override val listingLayout: String = "Listenlayout"
    override val device: String = "Gerät"
    override val cash: String = "Bargeld"
    override val eft: String = "EC"
    override val tips: String = "Trinkgeld"
    override val revenueGuest: String = "Umsatz/Gast"
    override val totalRevenue: String = "Gesamtumsatz"
    override val analizeQuestionProcess: String = "Frage wird analysiert..."
    override val generateSQLProcess: String = "SQL wird generiert..."
    override val formatAnswerProcess: String = "SQL wird formatiert..."
    override val createFilesProcess: String = "Dateien werden erstellt..."
    override val uploadFilesProcess: String = "Dateien werden hochgeladen..."
    override val generateMenuCardProcess: String = "Speisekarte wird generiert..."
    override val clearMenuCardProcess: String = "Speisekarte wird gelöscht..."
    override val prepareResultProcess: String = "Ergebnis wird vorbereitet..."
    override val menuCardProgressMessage: String = "Schritte sind abgeschlossen"
    override val menuCardSelectFilesMessages: String = "Wählen Sie Dateien (.pdf, .png, .jpg) nicht größer als 3MB"
    override val filesChosen: String = "Datei(en) ausgewählt"
    override val uploaded: String = "Hochgeladen"
    override val generalInfo: String = "Allgemeine Informationen"
    override val download: String = "Herunterladen"
    override val doYouWantToRemoveThisFloor: String = "Möchten Sie diese Etage entfernen?"
    override val doYouWantToRemoveThisRoom: String = "Möchten Sie diesen Raum entfernen?"
    override val floorNumber: String = "Etagennummer"
    override val addNewFloor: String = "Neue Etage hinzufügen"
    override val wall: String = "Wand"
    override val floor: String = "Etage"
    override val show3D: String = "3D anzeigen"
    override val addFloor: String = "Etage hinzufügen"
    override val interiorDecor: String = "Inneneinrichtung"
    override val add: String = "Hinzufügen"
    override val table: String = "Tisch"
    override val roomName: String = "Raumname"
    override val projectName: String = "Projektname"
    override val restaurantManager: String = "Restaurant Manager"
    override val addNewGroup: String = "Neue Gruppe hinzufügen"
    override val editGroup: String = "Gruppe bearbeiten"
    override val shopaffiliation: String = "Shopzugehörigkeit"
    override val dateInterval: String = "Datumsintervall"
    override val selfCheckout_1080_1920: String = "Selbstbedienungskasse (1024*600)"
    override val standard_1024_600: String = "Standard (1024*600)"
    override val addNewMedia: String = "Neue Medien hinzufügen"
    override val refreshTime: String = "Aktualisierungszeit"
    override val chooseAnArticle: String = "Artikel auswählen"
    override val advertisingDuringTyping: String = "Werbung während der Eingabe"
    override val fullDisplayAdvertising: String = "Vollbild-Werbung"
    override val stayActive: String = "Aktiv bleiben"
    override val media: String = "Medien"
    override val mediaCenter: String = "Medienzentrum"
    override val actions: String = "Aktionen"
    override val disableCompletion: String = "Abschluss deaktivieren"
    override val reason: String = "Grund"
    override val deactivateDailyClosing: String = "Tagesabschluss deaktivieren"
    override val group: String = "Gruppe"
    override val groupByDateShop: String = "Nach Datum/Shop gruppieren"
    override val groupByShop: String = "Nach Shop gruppieren"
    override val groupByDate: String = "Nach Datum gruppieren"
    override val inTotal: String = "Insgesamt"
    override val printFinancialStatements: String = "Finanzberichte drucken"
    override val selectedItem: String = "Ausgewählter Artikel"
    override val exportExcel: String = "Excel"
    override val price: String = "Preis"
    override val percentSign: String = "%"
    override val code: String = "Code"
    override val productDateShop: String = "Artikel-Datum-Shop"
    override val productDate: String = "Artikel-Datum"
    override val dateProduct: String = "Datum-Artikel"
    override val productShop: String = "Artikel-Shop"
    override val shopProduct: String = "Shop-Artikel"
    override val lastSale: String = "Letzter Verkauf"
    override val weight: String = "Gewicht"
    override val firstSale: String = "Erster Verkauf"
    override val groupedBy: String = "Gruppiert nach"
    override val notCancelled: String = "Nicht storniert"
    override val cancelled: String = "Storniert"
    override val userName: String = "Benutzername"
    override val total: String = "Gesamt"
    override val cancellation: String = "Stornierung"
    override val pdf: String = "PDF"
    override val abcStatistic: String = "ABC-Statistik"
    override val billSearch: String = "Rechnungssuche"
    override val setting: String = "Einstellung"
    override val statistic: String = "Statistik"
    override val threeWeeksAgo: String = "Vor 3 Wochen"
    override val twoWeeksAgo: String = "Vor 2 Wochen"
    override val lastWeek: String = "Letzte Woche"
    override val compare: String = "Vergleichen"
    override val sales: String = "Verkäufe"
    override val allTheRegions: String = "Alle Regionen"
    override val clients: String = "Kunden"
    override val workingHours: String = "Arbeitszeiten"
    override val hourlyRate: String = "Stundensatz"
    override val averageCheck: String = "Durchschnittlicher Scheck"
    override val turnOver: String = "Umsatz"
    override val euro: String = "€"
    override val cashRegisters: String = "Kassen"
    override val restaurantsOf: String ="Restaurants von"
    override val dashboard: String = "Dashboard"
    override val backgroundColor: String = "Hintergrundfarbe"
    override val fakeLatestPurchasesAndMore: String = "https://shortlink.com/**********"
    override val fakeQRCode: String = "0000-0000-0000-0000"
    override val fakeCustomerNumber: String = "0000001"
    override val incomeAndExpanse: String = "Einnahmen & Ausgaben"
    override val cashBookAndCoupons: String = "Kassenbuch & Gutscheine"
    override val credit: String = "Guthaben"
    override val pressets: String = "Voreinstellungen"
    override val apply: String = "Anwenden"
    override val amountCHF: String = "Betrag CHF"
    override val amount: String = "Betrag"
    override val difference: String = "Differenz"
    override val cashDelivery: String = "Bargeldlieferung"
    override val IsnInCHF: String = "ISN in CHF"
    override val course: String = "Kurs"
    override val lst: String = "LSt"
    override val currency: String = "Währung"
    override val reduction: String = "Reduktion"
    override val freeVat: String = "MwSt-frei"
    override val empty: String = "Leer"
    override val reports: String = "Berichte"
    override val FROM_DATE: String = "Von Datum"
    override val GROUP: String = "Gruppe"
    override val BALANCE: String = "Saldo"
    override val BOOKING_MODE: String = "Buchungsmodus"
    override val UNTIL_DATE: String = "Bis Datum"
    override val CHECKOUT: String = "Kasse"
    override val CREDIT: String = "Guthaben"
    override val POINTS: String = "Punkte"
    override val CHECKOUT_DATE: String = "Kassendatum"
    override val DESIGNATION: String = "Bezeichnung"
    override val DOCUMENT_NUMBER: String = "Belegnummer"
    override val BURDEN: String = "Belastung"
    override val POINTS_BALANCE: String = "Punktestand"
    override val CASH_REGISTER_TIME: String = "Kassenzeit"
    override val cashRegisterName: String = "Kassenname"
    override val selectDesiredColumns: String = "Gewünschte Spalten auswählen"
    override val transaction: String = "Transaktionen"
    override val addNewCustomerCard: String = "Neue Kundenkarte hinzufügen"
    override val digitalCustomerCard: String = "Digitale Kundenkarte"
    override val rfidCustomerCard: String = "RFID-Kundenkarte"
    override val zeroSetting: String = "Keine Einstellung"
    override val none: String = "Keine"
    override val discountGroup1: String = "Rabattgruppe 1"
    override val discountGroup2: String = "Rabattgruppe 2"
    override val discountGroup3: String = "Rabattgruppe 3"
    override val discountGroup4: String = "Rabattgruppe 4"
    override val discountGroup5: String = "Rabattgruppe 5"
    override val discountGroup6: String = "Rabattgruppe 6"
    override val discountGroup7: String = "Rabattgruppe 7"
    override val discountGroup8: String = "Rabattgruppe 8"
    override val discountGroup9: String = "Rabattgruppe 9"
    override val discountGroup10: String = "Rabattgruppe 10"
    override val discountGroup11: String = "Rabattgruppe 11"
    override val discountGroup12: String = "Rabattgruppe 12"
    override val discountGroup13: String = "Rabattgruppe 13"
    override val discountGroup14: String = "Rabattgruppe 14"
    override val discountGroup15: String = "Rabattgruppe 15"
    override val discountGroup16: String = "Rabattgruppe 16"
    override val discountGroup17: String = "Rabattgruppe 17"
    override val discountGroup18: String = "Rabattgruppe 18"
    override val discountGroup19: String = "Rabattgruppe 19"
    override val discountGroup20: String = "Rabattgruppe 20"
    override val inHouseCard: String = "Hauskarte"
    override val loyaltyCard: String = "Treuekarte"
    override val clientName: String = "Kundenname"
    override val salutation: String = "Anrede"
    override val resetBooking: String = "Buchung zurücksetzen"
    override val cardHolder: String = "Karteninhaber"
    override val loadLabels: String = "Etiketten laden"
    override val loadMaps: String = "Karten laden"
    override val loadingLabeling: String = "Laden/Etikettieren"
    override val labelingWorkCards: String = "Arbeitskarten etikettieren"
    override val loadingWorkCards: String = "Arbeitskarten laden"
    override val createCustomerCard: String = "Kundenkarte erstellen"
    override val until: String = "Bis"
    override val from: String = "Von"
    override val loyaltyCards: String = "Treuekarten"
    override val calculate: String = "Berechnung"
    override val end: String = "Ende"
    override val start: String = "Start"
    override val period: String = "Zeitraum"
    override val January: String = "Januar"
    override val February: String = "Februar"
    override val March: String = "März"
    override val April: String = "April"
    override val May: String = "Mai"
    override val June: String = "Juni"
    override val July: String = "Juli"
    override val August: String = "August"
    override val September: String = "September"
    override val October: String = "Oktober"
    override val November: String = "November"
    override val December: String = "Dezember"
    override val fourQuarters: String = "Q4"
    override val threeQuarters: String = "Q3"
    override val twoQuarters: String = "Q2"
    override val oneQuarter: String = "Q1"
    override val twoHalfAYear: String = "2. HALBJAHR"
    override val oneHalfAYear: String = "1. HALBJAHR"
    override val next: String = "Weiter"
    override val previous: String = "Zurück"
    override val previousWeek: String = "Letzte Woche"
    override val thisWeek: String = "Diese Woche"
    override val yesterday: String = "Gestern"
    override val today: String = "Heute"
    override val rfid: String = "RFID"
    override val barcode: String = "Barcode"
    override val collectPointsWhenCharged: String = "Punkte nur bei Aufladung sammeln"
    override val cardCanOnlyBeChargedByCash: String = "Karte kann nur mit Bargeld aufgeladen werden"
    override val grantDiscountOnNetItems: String = "Auch Rabatt auf Nettoartikel gewähren"
    override val grantDiscountWhenCharged: String = "Rabatt nur bei Aufladung gewähren"
    override val discountNumber: String = "Rabatt-Nr."
    override val discountGLWithPercent: String = "Rabatt GL, %"
    override val discountWithPercent: String = "Rabatt, %"
    override val debitCard: String = "EC-Karte"
    override val cardType: String = "Kartentyp"
    override val art: String = "Art"
    override val owner: String = "Inhaber"
    override val email: String = "E-Mail"
    override val telephone: String = "Telefon"
    override val firstName: String = "Vorname"
    override val address: String = "Adresse"
    override val zipCity: String = "PLZ"
    override val cardLimit: String = "Kartenlimit"
    override val dailyLimit: String = "Tageslimit"
    override val card: String = "Karte"
    override val cardNumber: String = "Kartennummer"
    override val lastUsed: String = "Zuletzt verwendet"
    override val internetAccessCode: String = "Internet-Zugangscode"
    override val series: String = "Serie"
    override val customerCards: String = "Kundenkarten"
    override val points: String = "Punkte"
    override val ipAddress: String = "IP-Adresse"
    override val kitchenPrinterSerialNumber: String = "Küchendrucker Seriennummer"
    override val addCakeDisplay: String = "Kuchenauslage hinzufügen"
    override val serialNumber: String = "Seriennummer"
    override val logout: String = "Abmelden"
    override val backToAdmin: String = "Zurück zum Adminmodus"
    override val myProfile: String = "Mein Profil"
    override val globalSearch: String = "Globale Suche"
    override val noItemToDisplay: String = "Keine Artikel zum Anzeigen"
    override val standardInBracket: String = "<Standard>"
    override val mwstNormal: String = "MwSt-Normal"
    override val salesVolume: String = "Umsatzvolumen"
    override val time: String = "Zeit"
    override val date: String = "Datum"
    override val closingReports: String = "Abschlussberichte"
    override val standardWithoutPrinting: String = "Standard ohne Druck"
    override val withCashReportAndCountProtocol: String = "Mit Kassenbericht und Zählprotokoll"
    override val withoutCash: String = "Ohne Bargeld"
    override val standard: String = "Standard"
    override val withCashReport: String = "Mit Kassenbericht"
    override val vatRateSelection: String = "MwSt-Satz Auswahl"
    override val specialVat: String = "Spezial-MwSt"
    override val reducedVat: String = "Reduzierte MwSt"
    override val normalVat: String = "Normal-MwSt"
    override val office: String = "Büro"
    override val priceLevel: String = "Preisstufe"
    override val region: String = "Region"
    override val priceLevelInHouseButton: String = "Preisstufe Vor-Ort-Button"
    override val branch: String = "Filiale"
    override val mode: String = "Modus"
    override val cashierName: String = "Kassierer Name"
    override val tableShift: String = "Tischverschiebung"
    override val copyForWaiter: String = "Kopie für Kellner"
    override val printer: String = "Drucker"
    override val printKitchenOnlyForTables: String = "Küchendruck nur für Tische"
    override val printReceiptAfterCompletion: String = "Küchendruck erst nach Belegabschluss"
    override val activeKitchenPrinter: String = "Küchendrucker aktivieren"
    override val receiptCopy: String = "Belegkopie"
    override val fromAmount: String = "Ab Betrag"
    override val variable: String = "Variabel"
    override val inTheHouse: String = "Im-Haus"
    override val degree: String = "Grad"
    override val activateEmployeeCompletion: String = "Mitarbeiterabschluss aktivieren"
    override val degreeType: String = "Gradart"
    override val close: String = "Schließen"
    override val previewForAppleWallet: String = "Vorschau für Apple Wallet"
    override val latestPurchasesAndMore: String = "Letzte Einkäufe und mehr"
    override val phone: String = "Telefon"
    override val qrCode: String = "QR-Code"
    override val customerName: String = "Kundenname"
    override val customerNumber: String = "Kundennummer"
    override val cardName: String = "Kartenname"
    override val specialDiscountTier: String = "Spezielle Rabattstufe"
    override val discountTier: String = "Rabattstufe"
    override val aboutTheCard: String = "Mehr zur Karte auf der Rückseite!"
    override val cashAssistCard: String = "Cash-Assist-Karte"
    override val balance: String = "Guthaben"
    override val customerCard: String = "Kundenkarte"
    override val previewForGoogleWallet: String = "Vorschau für Google Wallet"
    override val cardPreview: String = "Kartenvorschau"
    override val cardInfoPreview: String = "Karteninformationsvorschau"
    override val cashRegisterConfig: String = "Kassenkonfiguration"
    override val menuCardImport: String = "Speisekarten-Import"
    override val advertisingText: String = "Werbetext"
    override val optionalTwo: String = "Optional Zwei"
    override val optionalOne: String = "Optional Eins"
    override val vatNumber: String = "USt-IdNr."
    override val addition: String = "Zusatz"
    override val mfaCode: String = "MFA-Code"
    override val incomeExpanses: String = "Ein/Ausgaben"
    override val incomeExpanses1: String = "Ein/Ausgaben 1"
    override val incomeExpanses2: String = "Ein/Ausgaben 2"
    override val incomeExpanses3: String = "Ein/Ausgaben 3"
    override val incomeExpanses4: String = "Ein/Ausgaben 4"
    override val incomeExpanses5: String = "Ein/Ausgaben 5"
    override val name1: String = "Name 1"
    override val name2: String = "Name 2"
    override val name3: String = "Name 3"
    override val name4: String = "Name 4"
    override val name5: String = "Name 5"
    override val name6: String = "Name 6"
    override val name7: String = "Name 7"
    override val name8: String = "Name 8"
    override val name9: String = "Name 9"
    override val name10: String = "Name 10"
    override val creditCard: String = "Kreditkarte"
    override val cashFlow: String = "Cashflow"
    override val companyLogo: String = "Firmenlogo"
    override val colorIsMissing: String = "Farbe fehlt"
    override val titleFontColor: String = "Titelschriftfarbe"
    override val fontColor: String = "Schriftfarbe"
    override val preview: String = "Vorschau"
    override val wideCompanyLogo: String = "Breites Firmenlogo"
    override val heroImage: String = "Hauptbild"
    override val googleWallet: String = "Google Wallet"
    override val appleWallet: String = "Apple Wallet"
    override val website: String = "Webseite"
    override val titleWebsite: String = "Titel Webseite"
    override val telephoneNumber: String = "Telefonnummer"
    override val titleContact: String = "Titel Kontakt"
    override val title2: String = "Titel 2"
    override val titleField2: String = "Titelfeld 2"
    override val title1: String = "Titel 1"
    override val titleField1: String = "Titelfeld 1"
    override val description: String = "Beschreibung"
    override val emailCompany: String = "Firmen-E-Mail"
    override val activeCustomersCard: String = "Mobile Kundenkarten sind aktiv"
    override val virtualCard: String = "Virtuelle Karte"
    override val addNewLocation: String = "Neuen Standort hinzufügen"
    override val uploadFromPc: String = "Von lokal hochladen"
    override val prompt: String = "Eingabeaufforderung"
    override val question: String = "Ihre Frage"
    override val newImage: String = "Neues Bild"
    override val newMenuCard: String = "Neue Speisekarte"
    override val dataAssistant: String = "Datenassistent"
    override val price2: String = "Preis 2"
    override val price1: String = "Preis 1"
    override val numberDot: String = "Nr."
    override val addNewItem: String = "Neuen Artikel hinzufügen"
    override val variant1: String = "Variante 1"
    override val variant2: String = "Variante 2"
    override val variant3: String = "Variante 3"
    override val variant4: String = "Variante 4"
    override val variant5: String = "Variante 5"
    override val variant6: String = "Variante 6"
    override val variant7: String = "Variante 7"
    override val variant8: String = "Variante 8"
    override val variant9: String = "Variante 9"
    override val variant10: String = "Variante 10"
    override val kitchenInformation: String = "Kücheninformation"
    override val items: String = "Artikel"
    override val addNewSaleGroup: String = "Neue Verkaufsgruppe hinzufügen"
    override val submit: String = "Absenden"
    override val inactiveItems: String = "Inaktive Artikel"
    override val activeItems: String = "Aktive Artikel"
    override val allItems: String = "Alle Artikel"
    override val individualFilter: String = "Individueller Filter"
    override val creatingNewProduct: String = "Neues Artikel erstellen"
    override val numberOrNameIsWrong: String = "Nummer oder Name ist falsch"
    override val products: String = "Artikels"
    override val companyProfile: String = "Firmenprofil"
    override val imageAiDialogWaitingMsg: String = "Vorgang kann länger als 30 s dauern"
    override val menuCardAIDialogWaitingMsg: String = "Vorgang kann länger als 3 m dauern"
    override val generate: String = "Generieren"
    override val hint: String = "Hinweis"
    override val allDays: String = "Alle Tage"
    override val mondayFull: String = "Montag"
    override val tuesdayFull: String = "Dienstag"
    override val wednesdayFull: String = "Mittwoch"
    override val thursdayFull: String = "Donnerstag"
    override val fridayFull: String = "Freitag"
    override val saturdayFull: String = "Samstag"
    override val sundayFull: String = "Sonntag"
    override val selectDays: String = "Tage auswählen"
    override val color: String = "Farbe"
    override val changesValidFrom: String = "Änderungen gültig ab"
    override val surchargePercent: String = "Aufschlag %"
    override val away: String = "Außer Haus"
    override val surchargeAmount: String = "Aufschlagsbetrag"
    override val priceLevels: String = "Preisstufen"
    override val surchargeInHouse: String = "Aufschlag vor Ort"
    override val contain: String = "Enthält"
    override val allergens: String = "Allergene"
    override val deliveryTimeInDays: String = "Lieferzeit in Tagen"
    override val minimumOrder: String = "Mindestbestellung"
    override val maximumOrder: String = "Maximalbestellung"
    override val vat: String = "MwSt"
    override val printKitchenReceiptIfInfoSelected: String = "Küchendruck nur bei ausgewählter Kücheninformation"
    override val printKitchenReceiptIfInHouseActive: String = "Küchendruck nur bei aktiviertem Vor-Ort-Button"
    override val kitchen: String = "Küche"
    override val restaurant: String = "Restaurant"
    override val prices: String = "Preise"
    override val discount: String = "Rabatt"
    override val product: String = "Artikel"
    override val slash: String = "/"
    override val noDiscountPossible: String = "Kunden-Nettoartikel (kein Rabatt möglich)"
    override val employeeNetItems: String = "Mitarbeiter-Nettoartikel"
    override val employeeConsumption: String = "Mitarbeiterverbrauch"
    override val interimFinancialStatement: String = "Zwischenbilanz"
    override val enableUsersOnlyForTimeTracking: String = "Benutzer nur für Zeiterfassung aktivieren"
    override val allReceipts: String = "Alle Belege"
    override val noAuthorization: String = "Keine Berechtigung"
    override val onlyOwnReceipts: String = "Nur eigene Belege"
    override val gastronomy: String = "Gastronomie"
    override val shortName: String = "Kurzname"
    override val addNewUser: String = "Neuen Benutzer hinzufügen"
    override val addNewCategory: String = "Neue Kategorie hinzufügen"
    override val img: String = "Bild"
    override val menuCard: String = "Speisekarte"
    override val remove: String = "Entfernen"
    override val confirm: String = "Bestätigen"
    override val cancel: String = "Abbrechen"
    override val printName: String = "Druckname"
    override val users: String = "Benutzer"
    override val articleList: String = "Artikelliste"
    override val operation: String = "Betrieb"
    override val general: String = "Allgemein"
    override val userPhoto: String = "Benutzerfoto"
    override val title: String = "Titel"
    override val filter: String = "Filter"
    override val fibuNormal: String = "Fibu Normal"
    override val financialReduced: String = "Reduziert"
    override val accounting: String = "Buchhaltung"
    override val accountingPercent: String = "Buchhaltung 0%"
    override val article: String = "Artikel"
    override val template: String = "Schablone"
    override val options: String = "Optionen"
    override val salesGroups: String = "Verkaufsgruppen"
    override val clickAndCollect: String = "Click&Collect"
    override val update: String = "Aktualisieren"
    override val DAYS_END: String = "Tagesende"
    override val ADMINISTRATOR: String = "Administrator"
    override val MANAGER: String = "Manager (Manager kann auf andere Benutzer zugreifen)"
    override val NO_SALES_TRIGGER: String = "Kein Verkaufsauslöser (Maison)"
    override val cancellationRight: String = "Widerrufsrecht"
    override val receiptName: String = "Belegname"
    override val password: String = "Passwort"
    override val name: String = "Name"
    override val waitersCastle: String = "Kellnerburg"
    override val right: String = "Recht"
    override val devices: String = "Geräte"
    override val user: String = "Benutzer"
    override val search: String = "Suche"
    override val number: String = "Nummer"
    override val language: String = "Sprache"
    override val street: String = "Straße"
    override val label: String = "Bezeichnung"
    override val companyName: String = "Firmenname"
    override val zip: String = "PLZ"
    override val city: String = "Stadt"
    override val APP_NAME_PART1: String = "RunMy"
    override val APP_NAME_PART2: String = "Setup"
    override val saturday: String = "Sa"
    override val sunday: String = "So"
    override val monday: String = "Mo"
    override val tuesday: String = "Di"
    override val wednesday: String = "Mi"
    override val thursday: String = "Do"
    override val friday: String = "Fr"
    override val USER_NAME: String = "Jens Lehman"
    override val COMPANY_NAME: String = "HS-Soft AG"
    override val forgetYourPassword: String = "Passwort vergessen?"
    override val login: String = "Anmelden"
    override val enterYourPassword: String = "Geben Sie Ihr Passwort ein."
    override val enterYourEmail: String = "E-Mail eingeben *"
    override val status: String = "Status"
    override val spent: String = "Aufgewendete "
    override val sec: String = "Sek"
    override val steps: String = "Schritte"
    override val step: String = "Schritt"
    override val model: String = "Modell"
    override val tokens: String = "Tokens"
    override val expertMode: String = "Expertenmodus"
    override val arguments: String = "Argumente"
    override val activate: String = "Aktiviert"
    override val adminPin: String = "Admin PIN"
    override val adminPUK: String = "Admin PUK"
    override val tseType: String = "TSE Typ"
    override val printQRCode: String = "QR-Code drucken"
    override val timeadminPin: String = "Timeadmin PIN"
    override val timeadminPUK: String = "Timeadmin PUK"
    override val tseLocation: String = "TSE Lokation"
    override val tseInformation: String = "TSE Informationen"
    override val kitchenLocations: String = "Drucker standorte"
    override val topEdgeCm: String = "Oberer Rand (cm)"
    override val separateCakeToppings: String = "Kuchenzutaten trennen"
    override val kuchen: String = "Küche"
    override val buffet: String = "Buffet"
    override val downloadExpired: String = "Download abgelaufen"
    override val receiptPrinterSettings: String = "Beleg drucker"
    override val printerType: String = "Druckertyp"
    override val printerConnectionTarget: String = "Seriennummer / IP-Adresse"
    override val kitchenSettings: String = "Kücheneinstellungen"
    override val rooms: String = "Räume"
    override val companyNameEmptyHint: String = "Ein leerer Firmenname kann zu Fehlern auf Ihrer gesamten Site führen"
    override val separateKitchenReport: String = "Getrennte Küchenbelege"
    override val kitchenStationAnnounce: String = "Ankündigen"
    override val snOfKds: String = "Seriennummer des KDS"
    override val forgetPassInfo: String = "Verifizierungscode zum Zurücksetzen des Passworts wird an diese E-Mail gesendet."
    override val forgetPassInfo2: String = "Geben Sie den Verifizierungscode ein, der an Ihre E-Mail gesendet wurde, und setzen Sie Ihr neues Passwort."
    override val sendCode: String = "Code senden"
    override val verificationCode: String = "Bestätigungscode*"
    override val newPassword: String = "Neues Passwort*"
    override val confirmPassword: String = "Passwort bestätigen*"
    override val enterNewPassword: String = "Neues Passwort eingeben"
    override val enterNewPasswordAgain: String = "Passwort erneut eingeben"
    override val updatePassword: String = "Passwort aktualisieren"
    override val passwordRequirements: String = "Passwortanforderungen"
    override val passwordReqLength: String = "Mindestens 8 Zeichen lang"
    override val passwordReqLower: String = "Mindestens ein Kleinbuchstabe"
    override val passwordReqUpper: String = "Mindestens ein Großbuchstabe"
    override val passwordReqNumber: String = "Mindestens eine Zahl"
    override val passwordReqSpecial: String = "Mindestens ein Sonderzeichen"

    override val enterProductNumber: String = "Artikelnummer eingeben"
    override val enterProductName: String = "Artikelname eingeben"
    override val enterMediaNumber: String = "Mediennummer eingeben"
    override val enterMediaName: String = "Medienname eingeben"
    override val enterSaleGroupName: String = "Verkaufsgruppenname eingeben"
    override val enterSaleGroupNumber: String = "Verkaufsgruppennummer eingeben"
    override val enterCategoryName: String = "Kategoriename eingeben"
    override val enterCategoryNumber: String = "Kategorienummer eingeben"
    override val enterUserName: String = "Benutzername eingeben"
    override val enterUserNumber: String = "Benutzernummer eingeben"
    override val enterLocationName: String = "Standortname eingeben"
    override val enterLocationNumber: String = "Standortnummer eingeben"
    override val printEFTReceipt: String = "EFT-Beleg drucken"
    override val takeOver: String = "Übernehmen"
    override val addNewAlergene: String = "Neues Allergen hinzufügen"
    override val createCustomeAlergene: String = "Benutzerdefiniertes Allergen erstellen"
    override val keyword: String = "Schlüsselwort"
    override val unit: String = "Einheit"
    override val nutritionalValues: String = "Nährwerte"
    override val type = "Typ"
    override val startDate = "Startdatum"
    override val endDate = "Enddatum"
    override val startTime = "Startzeit"
    override val lambda_seconds = "Lambda Nutzungssekunden"
    override val data_size_kbytes = "Datenmenge KB"
    override val is_premium = "Ist Premium"
    override val file_count = "Dateianzahl"
    override val freeCredits = "Freiguthaben"
    override val premiumCredits = "Premium-Guthaben"
    override val freeCreditsInfo = "Wird für grundlegende Fragen und Operationen verwendet. Diese Guthaben werden monatlich erneuert und können nicht gekauft werden."
    override val premiumCreditsInfo = "Wird für erweiterte Analysen und KI-Funktionen verwendet. Kaufen Sie nach Bedarf mehr. Diese Guthaben verfallen nicht."
    override val creditsWarning = "werden knapp"
    override val learnMore = "Mehr erfahren"
    override val topUpCredits = "Guthaben aufladen"
    override val info = "Info"
    override val favorites = "Favoriten"
}